import { EyeOutlined } from '@ant-design/icons';
import { BackTop, Button, Layout } from 'antd';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConsentList from './components/ConsentList';
import ConsentDetail from './components/ConsentDetail';
import { useNavigate } from 'react-router-dom';
import ConsentService from '../../services/Consent.service';
import GlobalService from '../../services/Global.service';
import EmptyCustom from '../../assets/Images/icons/emptyCustom';
import usePermission from '../../hooks/usePermission';
export default function Consent() {
    const { t } = useTranslation();
    const [previewLang, setPreviewLang] = useState('th');
    const [data, setData] = useState([]);
    const [currentSelectList, setCurrentSelectList] = useState();
    const [applicationList, setApplicationList] = useState([]);
    const [consentData, setConsentData] = useState();
    const [searchValue, setSearchValue] = useState();
    const [searchTemplateCategory, setSearchTemplateCategory] = useState();
    const [dataTotal, setDataTotal] = useState();

    let navigate = useNavigate();

    const searchConsentList = async (value) => {
        try {
            const { data } = await ConsentService.searchConsentList(value);
            await setData(data?.resultData.result || []);
            await setCurrentSelectList(data?.resultData.result[0]);
            await setDataTotal(data?.resultData.total);
            setConsentData();
        } catch (error) {
            console.log(error);
        }
    };

    const getImage = async (id) => {
        const item = await GlobalService.getImage(id).then(({ data }) => {
            return `data:image/png;base64,${data.resultData?.imageId}`;
        });
        return item;
    };

    // ConsentDetail
    const [loadingDetail, setLoadingDetail] = useState(false);
    const getConsentDetail = async (consentId) => {
        setLoadingDetail(true);
        try {
            const { data } = await ConsentService.getConstentDetail(consentId);
            await setConsentData(data?.resultData);
            const appData = data?.resultData?.applicationRelated;
            const newItem = [];
            for (let _data of appData) {
                let img = '';
                if (_data?.applicationLogoId) {
                    img = await getImage(_data?.applicationLogoId);
                }
                newItem.push({
                    image: img ? img : '',
                    ..._data,
                });
            }
            await setApplicationList(newItem);
            await setLoadingDetail(false);
        } catch (error) {}
    };

    useEffect(() => {
        if (currentSelectList?.consentId) {
            getConsentDetail(currentSelectList?.consentId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSelectList]);

    const onViewApiDocument = () => {
        window.open('https://coda.io/d/_dpU8vfjfmIv/6-Acceptance-Daily_suIrL');
    };

    const { isAuditor } = usePermission();

    return (
        <>
            <div>
                <div className="title ">Consent</div>
                <div className="sub-title">
                    <span className="text-sm text-gray-400">
                        {t('common.ConsentManagement')} /
                    </span>
                    <span> Consent </span>
                </div>
            </div>

            <Layout>
                <div className="flex items-center my-4">
                    <div className="flex-1 font-bold text-xl">
                        {t('Consent.FileDocument')}
                    </div>
                    <div className="flex gap-2 justify-end">
                        <Button
                            disabled={isAuditor}
                            onClick={onViewApiDocument}
                            className="w-[150px] text-[#7B67FB] border-[#7B67FB]  text-tiny"
                            icon={<EyeOutlined />}
                            size="large"
                            type="default"
                        >
                            API Document
                        </Button>
                        <Button
                            disabled={isAuditor}
                            className="w-[150px] text-tiny"
                            onClick={() => navigate(`${'new'}`)}
                            type="primary"
                            size="large"
                        >
                            + {t('Consent.Add')}
                        </Button>
                    </div>
                </div>
                {true ? (
                    <div className="grid grid-cols-7 gap-4">
                        <ConsentList
                            previewLang={previewLang}
                            setPreviewLang={setPreviewLang}
                            data={data}
                            setCurrentSelectList={setCurrentSelectList}
                            currentSelectList={currentSelectList}
                            setSearchValue={setSearchValue}
                            searchValue={searchValue}
                            searchConsentList={searchConsentList}
                            setSearchTemplateCategory={
                                setSearchTemplateCategory
                            }
                            searchTemplateCategory={searchTemplateCategory}
                            dataTotal={dataTotal}
                        />
                        <ConsentDetail
                            currentSelectList={currentSelectList}
                            previewLang={previewLang}
                            setPreviewLang={setPreviewLang}
                            loadingDetail={loadingDetail}
                            consentData={consentData}
                            applicationList={applicationList}
                            data={data}
                        />
                    </div>
                ) : (
                    <div className="grid items-center justify-center mt-20">
                        <EmptyCustom text={t('common.noData')} />
                    </div>
                )}
            </Layout>
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
